import { sha256 } from '@noble/hashes/sha256';
import { ensureUint8Array } from 'micro-stacks/common';
import { sha512, sha512_256 } from '@noble/hashes/sha512';

function f(r){return sha256.create().update(ensureUint8Array(r)).digest()}function y(r){return sha512.create().update(ensureUint8Array(r)).digest()}function d(r){return sha512_256.create().update(ensureUint8Array(r)).digest()}

export { f as hashSha256, y as hashSha512, d as hashSha512_256 };
